<template lang="pug">
  component(:is="getComponent(item)" :item="item" :type="type")
</template>

<script>
import NotificationAccountBlocked from '@/components/notification/NotificationAccountBlocked.vue';
import NotificationAccountLowBalance from '@/components/notification/NotificationAccountLowBalance.vue';
import NotificationAccountWillBeDeleted from '@/components/notification/NotificationAccountWillBeDeleted.vue';
import NotificationBecomeProjectMember from '@/components/notification/NotificationBecomeProjectMember.vue';
import NotificationCommentPublish from '@/components/notification/NotificationCommentPublish.vue';
import NotificationCommentUpdate from '@/components/notification/NotificationCommentUpdate.vue';
import NotificationTaskPublish from '@/components/notification/NotificationTaskPublish.vue';
import NotificationTaskUpdate from '@/components/notification/NotificationTaskUpdate.vue';
import NotificationTaskExpires from '@/components/notification/NotificationTaskExpires.vue';
import NotificationContactRequestCreated from '@/components/notification/NotificationContactRequestCreated.vue';
import NotificationContactRequestAccepted from '@/components/notification/NotificationContactRequestAccepted.vue';
import NotificationContactRequestDeclined from '@/components/notification/NotificationContactRequestDeclined.vue';
import NotificationProjectReferralSampleCreate from '@/components/notification/NotificationProjectReferralSampleCreate.vue';
import NotificationProjectReferralSampleUpdate from '@/components/notification/NotificationProjectReferralSampleUpdate.vue';

export default {
  name: 'NotificationComponentSelector',
  components: {
    NotificationAccountBlocked,
    NotificationAccountLowBalance,
    NotificationAccountWillBeDeleted,
    NotificationBecomeProjectMember,
    NotificationCommentPublish,
    NotificationCommentUpdate,
    NotificationTaskPublish,
    NotificationTaskUpdate,
    NotificationTaskExpires,
    NotificationContactRequestCreated,
    NotificationContactRequestAccepted,
    NotificationContactRequestDeclined,
    NotificationProjectReferralSampleCreate,
    NotificationProjectReferralSampleUpdate,
  },
  props: {
    item: Object,
    type: String,
  },
  methods: {
    getComponent(notification) {
      const isTaskUpdate = notification.type === 'task-closure'
        || notification.type === 'task-checklist-check'
        || notification.type === 'task-checklist-change'
        || notification.type.startsWith('task-update-')
        || notification.type.startsWith('become-task-');

      if (isTaskUpdate) {
        return 'NotificationTaskUpdate';
      }

      if (notification.type.startsWith('task-expires')) {
        return 'NotificationTaskExpires';
      }

      const type = notification.type
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.substring(1))
        .join('');
      return `Notification${type}`;
    },
  },
};
</script>

<style scoped>

</style>
